import React from 'react';
import moment from 'moment';
import { useParams, useNavigate } from 'react-router-dom';
import { useMealPlanDetail, useUpdateMealPlan, useDeleteMealPlan } from 'hooks';
import { TMealPlanFormData } from 'interfaces/mealPlan';
import { Form, Table, Button, Modal, type TableColumnsType } from 'antd';

import MealPlanForm from './components/MealPlanForm';
import { PageWrapper } from './styles';

const { useForm } = Form;

const columns: TableColumnsType = [
  { title: '매우 불만족', dataIndex: 'satisfactionScore1Count', width: '14.28%', align: 'center' },
  { title: '불만족', dataIndex: 'satisfactionScore2Count', width: '14.28%', align: 'center' },
  { title: '보통', dataIndex: 'satisfactionScore3Count', width: '14.28%', align: 'center' },
  { title: '만족', dataIndex: 'satisfactionScore4Count', width: '14.28%', align: 'center' },
  { title: '매우 만족', dataIndex: 'satisfactionScore5Count', width: '14.28%', align: 'center' },
  { title: '합계', dataIndex: 'totalSurveyResponseCount', width: '14.28%', align: 'center' }
];

const MealPlanEditPage = () => {
  const [form] = useForm();
  const { mealPlanIdx } = useParams();
  const navigate = useNavigate();

  const { mutate: getMealPlanDetail, data } = useMealPlanDetail();
  const { mutateAsync: updateMealPlan } = useUpdateMealPlan();
  const { mutateAsync: deleteMealPlan } = useDeleteMealPlan();

  React.useEffect(() => {
    if (mealPlanIdx) {
      getMealPlanDetail(mealPlanIdx);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mealPlanIdx]);

  const dataSource = data ? [data] : [];
  const formData = React.useMemo(() => {
    return {
      categoryId: data?.categoryId,
      content: data?.content,
      serveDate: data?.serveDate,
      mealPlanImage: data?.imageUrl,
      mealPlanName: data?.mealPlanName,
      isUseMealPlanItem: data?.isUseMealPlanItem,
      isUseSatisfactionSurvey: data?.isUseSatisfactionSurvey,
      isDeleteImage: data?.isDeleteImage,
      items: data?.mealPlanItems
    };
  }, [data]);

  const handleSubmit = async (values: TMealPlanFormData) => {
    if (!mealPlanIdx) return;
    const { mealPlanImage, serveDate, ...other } = values;
    const request = JSON.stringify({ ...other, serveDate: moment(serveDate).format('YYYY-MM-DD') });

    const params = new FormData();
    params.append('request', new Blob([request], { type: 'application/json' }));
    params.append('mealPlanImage', mealPlanImage);

    await updateMealPlan({ mealPlanIdx, params });

    Modal.info({
      className: 'info-handler-modal',
      content: `식단표가 수정되었습니다.`,
      icon: null,
      okText: '확인'
    });
    navigate('/mealPlan');
  };

  const handleMealPlanDelete = () => {
    Modal.confirm({
      className: 'confirm-cancel-handler-modal',
      content: `식단표를 삭제하시겠습니까?`,
      icon: null,
      okText: '네, 삭제합니다',
      cancelText: '취소',
      onOk: async () => {
        await deleteMealPlan(mealPlanIdx);
        navigate('/mealPlan');
      }
    });
  };

  return (
    <PageWrapper>
      <MealPlanForm form={form} formData={formData} onSubmit={handleSubmit}>
        <Table dataSource={dataSource} columns={columns} pagination={false} />
        <div className="survey-comment-list">
          {data?.surveyCommentList?.map((comment) => <div className="survey-comment-item">{comment}</div>)}
        </div>
        <div style={{ display: 'flex', gap: '16px', justifyContent: 'end', marginTop: '24px' }}>
          <Button className="default-button-style" onClick={() => navigate('/mealPlan')}>
            취소
          </Button>
          <Button className="default-button-style" danger type="primary" onClick={handleMealPlanDelete}>
            삭제
          </Button>
          <Button className="default-button-style" type="primary" htmlType="submit">
            수정하기
          </Button>
        </div>
      </MealPlanForm>
    </PageWrapper>
  );
};

export default MealPlanEditPage;
